<div class="access-denied-wrapper">
  <mat-card class="custom-mat-card access-denied-card">
    <mat-card-title class="custom-card-title">{{ 'COMMON.COMING_SOON' | translate }}</mat-card-title>
    <button mat-flat-button color="primary" routerLink="/dashboard">{{ 'COMMON.RETURN_TO_DASHBOARD' | translate }}</button>
  </mat-card>
</div>
